<script>
import {
  getApplications,
  uploadFiles,
  updateApplication,
  getUserByNetId,
  getApplicationById,
} from "../services/services";
import LSDatePicker from "../components/LSDatePicker.vue";
import _ from "lodash";
export default {
  name: "Submissions",
  components: { LSDatePicker },
  data() {
    return {
      submissions: [],
      tableHeaders: [
        {
          text: "Student",
          align: "left",
          sortable: true,
          value: "fullName",
        },
        {
          text: "Date Submitted",
          align: "center",
          sortable: true,
          value: "dateSubmitted",
        },
        {
          text: "View Application Details",
          align: "center",
          sortable: false,
          width: "200px",
          value: "link",
        },
        {
          text: "Edit Application",
          align: "center",
          sortable: false,
          width: "200px",
          value: "edit",
        },
        {
          text: "Upload Letter of Recommendation",
          align: "center",
          sortable: false,
          value: "upload",
          width: "200px",
        },
      ],
      citizenshipOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      fellowships: ["", "", ""],
      location: "",
      letter: {},
      resume: {},
      thankYouNote: {},
      renderKey: 0,
      searchText: "",
      viewApplicationDialog: false,
      editApplication: false,
      letterUploadDialog: false,
      applicationBeingEdited: {},
      user: {},
      key: 1,
    };
  },
  methods: {
    startingAPICalls() {
      getUserByNetId(this.$store.state.User.netId).then((data) => {
        this.user = data;
        if (this.user.roleId > 2 || !this.user.roleId) {
          this.$router.push("/");
        }
      });

      getApplications().then((data) => {
        data.forEach((application) => {
          application.fellowships = application.sitesApplying.split(",");
          application.professorSendSeperate = application.recommendationSentSeperate
            ? "Yes"
            : "No";
          application.startDate = new Date(
            application.startDate
          ).toLocaleDateString();
          application.endDate = new Date(
            application.endDate
          ).toLocaleDateString();
          application.fullName =
            application.lastName + ", " + application.firstName;
          application.professorSendSeperate = application.professorEmail
            ? true
            : false;
          if(application.dateSubmitted){
          this.submissions.push(application);
          }
        });
      });
    },
    openEditDialog(application) {
      this.applicationBeingEdited = _.cloneDeep(application);
      this.editApplication = true;
      this.viewApplicationDialog = true;
    },
    openFileUploadDialog(application) {
      this.applicationBeingEdited = _.cloneDeep(application);
      this.letterUploadDialog = true;
    },
    closeApplicationDialog() {
      this.viewApplicationDialog = false;
      this.editApplication = false;
      setTimeout(() => {
        this.key++;
      }, 300);
    },
    closeDialogs() {
      this.letterUploadDialog = false;
      this.viewApplicationDialog = false;
    },
    async save() {
      this.applicationBeingEdited.sitesApplying = this.applicationBeingEdited.fellowships.join(
        ", "
      );
      await updateApplication(this.applicationBeingEdited).then((data) => {
        let indexToUpdate = this.submissions.findIndex(
          (application) => application.id == this.applicationBeingEdited.id
        );
        this.submissions[indexToUpdate] = this.applicationBeingEdited;
        this.renderKey++;
      });
      await this.saveFiles();
      this.submissions = [];
      await getApplications().then((data) => {
        data.forEach((application) => {
          application.fellowships = application.sitesApplying.split(",");
          application.professorSendSeperate = application.recommendationSentSeperate6
            ? "Yes"
            : "No";
          application.startDate = new Date(
            application.startDate
          ).toLocaleDateString();
          application.endDate = new Date(
            application.endDate
          ).toLocaleDateString();
          application.fullName =
            application.lastName + ", " + application.firstName;
          application.professorSendSeperate = data.recommendationSentSeperate
            ? "My Professor will send my letter"
            : "I will upload the letter";
          this.submissions.push(application);
        });
      });
      this.closeDialogs();
    },
    async saveFiles() {
      //this.applicationBeingEdited.letter = this.letterOfRecommendation;
      await this.uploadFiles();
      getApplicationById(this.applicationBeingEdited.id).then((data) => {
        let indexOfSubmissionToUpdate = this.submissions.indexOf(
          this.submissions.find((app) => app.id == data.id)
        );
        this.submissions[indexOfSubmissionToUpdate] = data;
        this.submissions[
          indexOfSubmissionToUpdate
        ].fellowships = this.submissions[
          indexOfSubmissionToUpdate
        ].sitesApplying.split(",");
        this.submissions[indexOfSubmissionToUpdate].professorSendSeperate = this
          .submissions[indexOfSubmissionToUpdate].recommendationSentSeperate
          ? "Yes"
          : "No";
        this.submissions[indexOfSubmissionToUpdate].startDate = new Date(
          this.submissions[indexOfSubmissionToUpdate].startDate
        ).toLocaleDateString();
        this.submissions[indexOfSubmissionToUpdate].endDate = new Date(
          this.submissions[indexOfSubmissionToUpdate].endDate
        ).toLocaleDateString();
        this.submissions[indexOfSubmissionToUpdate].fullName =
          this.submissions[indexOfSubmissionToUpdate].lastName +
          ", " +
          this.submissions[indexOfSubmissionToUpdate].firstName;
        this.submissions[
          indexOfSubmissionToUpdate
        ].professorSendSeperate = data.recommendationSentSeperate
          ? "My Professor will send my letter"
          : "I will upload the letter";
      });
      this.applicationBeingEdited = {};
    },

    async uploadFiles() {
      const form = new FormData();
      if (!!this.applicationBeingEdited.resume) {
        form.append(
          `r-${this.applicationBeingEdited.resume.name}`,
          this.applicationBeingEdited.resume
        );
      }
      if (!!this.applicationBeingEdited.letter) {
        form.append(
          `l-${this.applicationBeingEdited.letter.name}`,
          this.applicationBeingEdited.letter
        );
      }
      if (!!this.thankYouNote) {
        form.append(
          `t-${this.applicationBeingEdited.thankYouLetter.name}`,
          this.applicationBeingEdited.thankYouLetter
        );
      }

      if (!form.entries().next().done) {
        await uploadFiles(form, this.applicationBeingEdited.id);
      }
    },
  },
  computed: {
    startYear() {
      const NOW = new Date();
      return NOW.getFullYear();
    },
  },
  created() {
    this.startingAPICalls();
  },
};
</script>

<template>
  <div>
    <v-text-field
      v-model="searchText"
      label="Search"
      prepend-icon="search"
      clearable
    >
    </v-text-field>
    <v-data-table
      :key="renderKey"
      :headers="tableHeaders"
      :items="submissions"
      :search="searchText"
    >
      <template v-slot:item.dateSubmitted="{ item }">
          <p>{{new Date(item.dateSubmitted).toLocaleDateString()}}</p>
      </template>
      <template v-slot:item.link="{ item }">
        <router-link :to="'apply?id=' + item.id">
          <v-btn icon @click="viewApplicationDialog = true">
            <v-icon>launch</v-icon>
          </v-btn>
        </router-link>
      </template>
      <template v-slot:item.edit="{ item }">
        <v-btn icon @click="openEditDialog(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.upload="{ item }">
        <v-btn icon @click="openFileUploadDialog(item)">
          <v-icon>mdi-cloud-upload</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-model="letterUploadDialog"
      max-width="500"
      @click:outside="closeDialogs()"
    >
      <v-card>
        <v-card-title>Upload letter of recommendation</v-card-title>
        <v-card-text>
          <v-file-input
            label="Letter of recommendation"
            v-model="applicationBeingEdited.letter"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="save()">
            Upload
          </v-btn>
          <v-btn @click="closeDialogs()">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="viewApplicationDialog"
      max-width="1500"
      height="1"
      :key="key"
    >
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar dark color="primary" class="mb-6">
            <v-toolbar-title
              ><h3>
                {{
                  editApplication
                    ? "Editing application"
                    : "Viewing application"
                }}
              </h3></v-toolbar-title
            >
            <v-spacer />
            <v-btn icon @click="closeApplicationDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-layout column>
            <h1 style="padding-bottom: 16px">Personal Information</h1>
            <v-layout>
              <v-flex style="padding-right: 16px">
                <v-text-field
                  outlined
                  label="First Name"
                  v-model="applicationBeingEdited.firstName"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  outlined
                  label="Last Name"
                  v-model="applicationBeingEdited.lastName"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex style="padding-right: 16px">
                <v-text-field
                  outlined
                  label="NetID"
                  v-model="applicationBeingEdited.netId"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-select
                  outlined
                  label="Year In School"
                  v-model="applicationBeingEdited.yearInSchool"
                  :items="['Freshman', 'Sophomore', 'Junior', 'Senior']"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex style="padding-right: 16px">
                <v-text-field
                  outlined
                  label="Major"
                  v-model="applicationBeingEdited.major"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  outlined
                  label="GPA"
                  v-model="applicationBeingEdited.gpa"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex style="padding-right: 16px">
                <v-text-field
                  outlined
                  label="Phone Number"
                  v-model="applicationBeingEdited.phoneNumber"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  outlined
                  label="Email"
                  v-model="applicationBeingEdited.email"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex style="padding-right: 16px">
                <v-text-field
                  outlined
                  label="Mailing Address"
                  v-model="applicationBeingEdited.address"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex style="padding-right: 16px">
                <v-text-field
                  outlined
                  label="City"
                  v-model="applicationBeingEdited.city"
                ></v-text-field>
              </v-flex>
              <v-flex style="padding-right: 16px">
                <v-text-field
                  outlined
                  label="State"
                  v-model="applicationBeingEdited.state"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  outlined
                  label="Zip Code"
                  v-model="applicationBeingEdited.zip"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <h1 style="padding-bottom: 16px">Academic Information</h1>
            <v-layout>
              <v-flex style="padding-right: 16px" md6>
                <v-select
                  outlined
                  label="Are you a United States citizen?"
                  v-model="applicationBeingEdited.usCitizen"
                  :items="citizenshipOptions"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex style="padding-bottom: 16px">
                For which inspired learning fellowship(s) are you applying? (Max
                3) If you would like to apply for more than one internship,
                please list in ranked order, one being the most desired.
              </v-flex>
            </v-layout>
            <v-layout>
              <v-layout
                v-for="(f, i) in applicationBeingEdited.fellowships"
                :key="i + '-ksnd'"
                align-center
              >
                <v-text-field
                  outlined
                  v-model="applicationBeingEdited.fellowships[i]"
                  :label="'Fellowship ' + (i + 1)"
                  :style="i < 2 ? 'padding-right: 16px' : ''"
                ></v-text-field>
              </v-layout>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field
                  label="Internship Location"
                  v-model="applicationBeingEdited.locationOfInternship"
                  outlined
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6 style="padding-right: 16px">
                <LSDatePicker
                  :startYear="startYear"
                  :endYear="startYear + 10"
                  v-model="applicationBeingEdited.startDate"
                  title="Start Date"
                ></LSDatePicker>
              </v-flex>
              <v-flex md6>
                <LSDatePicker
                  :startYear="startYear + 1"
                  :endYear="startYear + 11"
                  title="End Date"
                  v-model="applicationBeingEdited.endDate"
                ></LSDatePicker>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6 style="padding-right: 16px">
                <v-text-field
                  outlined
                  label="Year"
                  v-model="applicationBeingEdited.year"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-select
                  :items="[
                    'Biology',
                    'Exercise Sciences',
                    'Microbiology and Moleculary Biology',
                    'Nutrition, Dietetics and Food Science',
                    'Physiology and Developmental Biology',
                    'Plant and Wildlife Sciences',
                    'Public Health',
                  ]"
                  outlined
                  label="Department"
                  v-model="applicationBeingEdited.department"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6 style="padding-right: 16px">
                <v-text-field
                  outlined
                  label="Course Number"
                  v-model="applicationBeingEdited.courseNumber"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-select
                  :items="['Fall', 'Winter', 'Spring/Summer']"
                  outlined
                  label="Semester"
                  v-model="applicationBeingEdited.semester"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout style="padding-bottom: 16px">
              To qualify for the fellowship you must have a letter of
              recommendation from one current faculty member with whom you have
              done research. You can either upload it here, or have the faculty
              member email it to michael_stark@byu.edu.
            </v-layout>

            <v-layout>
              <v-flex md6>
                <div v-if="!applicationBeingEdited.professorEmail">
                <br /><br /><br />
                </div>
                <v-select
                  :items="[
                    { name: 'My professor will send my letter', value: true },
                    { name: 'I will upload the letter', value: false },
                  ]"
                  item-text="name"
                  item-value="value"
                  outlined
                  label="Letter upload options"
                  v-model="applicationBeingEdited.professorSendSeperate"
                  disabled
                ></v-select>
              </v-flex>
              <v-flex v-if="!applicationBeingEdited.professorEmail" md6>
                <div
                  v-if="
                    Object.keys(applicationBeingEdited).length != 0 &&
                      (applicationBeingEdited.letterOfReccomendation.fileName ||
                        applicationBeingEdited.letterOfReccomendation.name)
                  "
                >
                  Current letter of recommendation file name:
                  {{
                    applicationBeingEdited.letterOfReccomendation.fileName
                      ? applicationBeingEdited.letterOfReccomendation.fileName
                      : applicationBeingEdited.letterOfReccomendation.name
                  }}
                </div>
                <br />

                <v-file-input
                  outlined
                  label="Letter of Recommendation"
                  v-model="applicationBeingEdited.letter"
                ></v-file-input>
              </v-flex>
              <v-flex v-else style="padding-left: 16px" md6>
                <v-text-field
                  label="Professor Email"
                  v-model="applicationBeingEdited.professorEmail"
                  outlined
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout style="padding-bottom: 16px">
              <div>
                Each fellowship is funded by donors who are anxious to support
                elite student research internships. Express your sincere
                appreciation and include:
                <ul>
                  <li>The goals of your research</li>
                  <li>
                    Your educational or professional plans following the
                    fellowship
                  </li>
                  <li>How the fellowship will help you achieve those goals</li>
                  <li>A picture of yourself</li>
                </ul>
              </div>
            </v-layout>
            <v-layout>
              <v-flex md6 style="padding-right: 16px">
                <div
                  v-if="
                    Object.keys(applicationBeingEdited).length != 0 &&
                      (applicationBeingEdited.resume.fileName ||
                        applicationBeingEdited.resume.name)
                  "
                >
                  Current resume file name:
                  {{
                    applicationBeingEdited.resume.fileName
                      ? applicationBeingEdited.resume.fileName
                      : applicationBeingEdited.resume.name
                  }}
                </div>
                <br />
                <v-file-input
                  outlined
                  label="Upload different resume"
                  v-model="applicationBeingEdited.resume"
                ></v-file-input>
              </v-flex>
              <v-flex>
                <div
                  v-if="
                    Object.keys(applicationBeingEdited).length != 0 &&
                      (applicationBeingEdited.thankYouLetter.fileName ||
                        applicationBeingEdited.thankYouLetter.name)
                  "
                >
                  Current thank you note file name:
                  {{
                    applicationBeingEdited.thankYouLetter.fileName
                      ? applicationBeingEdited.thankYouLetter.fileName
                      : applicationBeingEdited.thankYouLetter.name
                  }}
                </div>
                <br />
                <v-file-input
                  outlined
                  label="Thank You Note"
                  v-model="applicationBeingEdited.thankYouLetter"
                ></v-file-input>
              </v-flex>
            </v-layout>
            <v-textarea
              outlined
              label="Research Experience"
              v-model="applicationBeingEdited.researchExperience"
            ></v-textarea>
            <v-textarea
              outlined
              label="School Career Aspirations"
              v-model="applicationBeingEdited.careerAspirations"
            ></v-textarea>
            <v-textarea
              outlined
              label="Unique Qualifications"
              v-model="applicationBeingEdited.uniqueQualifications"
            ></v-textarea>
            <v-layout justify-end>
              <v-btn color="primary" @click="save()">Save Changes</v-btn>
            </v-layout>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style></style>
